import { useMemo } from 'react';
import { useMsal } from '@azure/msal-react';
import { AppRoleService, type AppRole } from '../services/appRoleService';

/**
 * Resolves the signed-in user's app role (Installer/Manager) from the Azure AD
 * `roles` claim. Mirrors useP2PRole, but reads app roles instead of groups.
 */
export function useAppRole(): { role: AppRole; isInstaller: boolean; isManager: boolean } {
  const { accounts } = useMsal();
  const role = useMemo<AppRole>(() => {
    const claims = accounts[0]?.idTokenClaims as Record<string, unknown> | undefined;
    const roles = claims?.roles as string[] | undefined;
    return AppRoleService.resolveRole(roles);
  }, [accounts]);
  return { role, isInstaller: role === 'Installer', isManager: role === 'Manager' };
}
